import React from "react";
import PropTypes from "prop-types";
import {Button, Checkbox, Form, Icon, Input} from "antd";
import {NavLink, withRouter, Redirect} from "react-router-dom";
import {compose} from 'recompose';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as AuthActions from "../reducers/auth";
import logo from "../../img/Logo-green-aPureBase-geen.png";
import InternetExplorerAlert from "../util/InternetExplorerAlert";

const FormItem = Form.Item;

class LoginPage extends React.Component {

    state = {
        email: '',
        password: '',
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const {form: {validateFields}, login} = this.props;
        validateFields((err, values) => !err && login(values));
    };

    validateLoggedIn = () => {
        // const loggedIn = store.getState().auth.loggedIn;
        // console.log('check logged in', store.getState(), loggedIn, this.props.loggedIn);
        // if (!loggedIn) return null;
        // const {pathname} = props.location.from || { from: {pathname: '/'}};
        // return <Redirect to={pathname === '/login' || !pathname ? '/' : pathname} />;
    };

    getPathname = () => {
        const {pathname} = this.props.location.from || { from: { pathname: '/'}};
        return pathname === '/login' || !pathname ? '/' : pathname
    };

    render() {
        const {loggedIn, form: {getFieldDecorator}, loading} = this.props;

        if (loggedIn) return <Redirect to={this.getPathname()} />;

        return <div className="login-page">
            <div className="login-header">
                <img src={logo} alt="aPureBase" />
                <p className="login-subtitle">Database Platform</p>
            </div>
            <Form onSubmit={this.handleSubmit} className="login-form">
                <FormItem>
                    {getFieldDecorator('email', {
                        rules: [{required: true, message: 'Please input your email!'}],
                    })(
                        <Input prefix={<Icon type="mail" style={{fontSize: 13}}/>} placeholder="Email"/>
                    )}
                </FormItem>
                <FormItem>
                    {getFieldDecorator('password', {
                        rules: [{required: true, message: 'Please input your Password!'}],
                    })(
                        <Input prefix={<Icon type="lock" style={{fontSize: 13}}/>} type="password"
                               placeholder="Password"/>
                    )}
                </FormItem>
                <FormItem>
                    {getFieldDecorator('remember', {
                        valuePropName: 'checked',
                        initialValue: true,
                    })(
                        <Checkbox>Remember me</Checkbox>
                    )}
                    <NavLink className="login-form-forgot" to="/login/help">Forgot password</NavLink>
                    <Button type="primary" htmlType="submit" className="login-form-button"
                            loading={loading}>
                        Log in
                    </Button>
                </FormItem>
                <InternetExplorerAlert/>
            </Form>
        </div>
    }
}

LoginPage.propTypes = {
    email: PropTypes.string,
    loggedIn: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    email: state.auth.email,
    loggedIn: state.auth.loggedIn,
    loading: state.auth.loading,
});

const mapDispatchToProps = dispatch => ({
    login: bindActionCreators(AuthActions, dispatch).login,
});

export default compose(
    withRouter,
    Form.create(),
    connect(mapStateToProps, mapDispatchToProps),
)(LoginPage);



// WEBPACK FOOTER //
// ./src/js/auth/LoginPage.js